<ng-template #content let-modal>

    <div class="modal-header">
        <h5 class="modal-title white" id="exampleModalLabel">Selección de terminal</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true"><img src="./assets/img/times2.svg" class="img-fluid ico-title" width="20"></span>
        </button>
    </div>

    <div class="modal-body modal-body-terminal" *ngIf="loaded">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <h6 class="subtitulo-pack-form">Filtrado:</h6>

                    <div class="form-row">

                        <div class="col-lg-4 mt-1" *ngIf="isKratos || typeOperation === 'portability'">
                            <div class="form-group">
                                <select id="tipo-pago" (change)="selectFilterPaymentType($event.target.value)">
                                    <option value="-1">-</option>
                                    <option *ngFor="let tipo of paymentTypes" value="{{ tipo.id }}">{{ tipo.name }}</option>
                                </select>
                                <label for="tipo-pago" class="control-label">Tipo de pago*</label><i class="bar"></i>
                            </div>
                        </div>

                        <div class="mt-1" [ngClass]="{'col-lg-4' : isKratos || typeOperation === 'portability', 'col-lg-6' : !isKratos && typeOperation !== 'portability'}">
                            <div class="form-group">
                                <select id="marca" (change)="selectFilterBrand($event.target.value)">
                                    <option value="">-</option>
                                    <option *ngFor="let marca of brands" value="{{ marca }}">{{ marca }}</option>
                                </select>
                                <label for="marca" class="control-label">Marca*</label><i class="bar"></i>
                            </div>
                        </div>

                        <div class="mb-0" [ngClass]="{'col-lg-4' : isKratos || typeOperation === 'portability', 'col-lg-6' : !isKratos && typeOperation !== 'portability'}">
                            <div class="form-group">
                                <input id="modelo" type="text" oninvalid="" (input)="inputModel($event.target.value)" required>
                                <label for="modelo" class="control-label">Modelo*</label><i class="bar"></i>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-5 mb-5">

                        <div class="col-xl-4 col-md-6" *ngFor="let terminal of terminalsFiltered">
                            <div class="mb-5 mb-sm-3">
                                <div class="row">
                                    <div class="col-lg-5 col-md-12 col-5">
                                        <img src="{{ terminal.img }}" class="img-fluid" alt="...">
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-7">
                                        <div *ngIf="isKratos">
                                            <h5 class="card-title smartphone-title mt-3">{{ terminal.name }}</h5>
                                            <ng-container *ngFor="let payment of terminal.payments">
                                                <ng-container *ngIf="(typeOperation === 'registration_logistica' && payment.order_type === 'new_order') || (typeOperation === 'registration' && payment.order_type === 'new_order') || (typeOperation === 'portability_logistica' && payment.order_type === 'portability') || (typeOperation === 'portability' && payment.order_type === 'portability')">
                                                    <p class="card-text smartphone-title-2" *ngIf="+payment.payment_quota > 0">
                                                        <span class="fw-bold">{{ payment.payment_quota }} €/mes</span> en {{ payment.payment_months }} meses
                                                        <br>
                                                        Pago inicial: <span class="fw-bold">{{ payment.initial_payment }}€</span>
                                                        <br><br>
                                                        <button class="btn btn-green btn-sm" (click)="selectTerminalAndPayment(terminal, 'VAP')">Elegir pago a plazos</button>
                                                    </p>
                                                    <p class="card-text smartphone-title-2" *ngIf="+payment.price > 0">
                                                        Pago único: <span class="fw-bold">{{ payment.price }}€</span>
                                                        <br><br>
                                                        <button class="btn btn-green btn-sm" (click)="selectTerminalAndPayment(terminal, 'unico')">Elegir pago único</button>
                                                    </p>
                                                </ng-container>
                                            </ng-container>
                                        </div>
                                        <div *ngIf="!isKratos">
                                            <h5 class="card-title smartphone-title mt-3">{{ terminal.brand }} {{ terminal.name }}</h5>
                                            <p class="card-text smartphone-title-2" *ngIf="terminal.payment_quota > 0 && (typeOperation === 'portability' || typeOperation === 'portability_logistica' || isAmenaEnCasa)">
                                                <span class="fw-bold">{{ terminal.payment_quota }} €/mes</span> en {{ terminal.payment_months }} meses
                                                <br>
                                                Pago inicial: <span class="fw-bold">{{ terminal.initial_payment }}€</span>
                                                <br><br>
                                                <button class="btn btn-green btn-sm" (click)="selectTerminalAndPayment(terminal, 'VAP')">Elegir pago a plazos</button>
                                            </p>
                                            <p class="card-text smartphone-title-2" *ngIf="terminal.price > 0">
                                                Pago único: <span class="fw-bold">{{ terminal.price }}€</span>
                                                <br><br>
                                                <button class="btn btn-green btn-sm" (click)="selectTerminalAndPayment(terminal, 'unico')">Elegir pago único</button>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-12 text-center" *ngIf="terminalsFiltered.length === 0">
                            No hay terminales.
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!loaded" class="mt-2 mb-5">
        <h5 align="center" class="tar-name-preload">Obteniendo terminales...</h5>
    
        <div align="center">
            <img class="" src="./assets/img/spinner.svg" width="30" alt="">
        </div>
    </div>
</ng-template>

<h6 class="subtitulo-pack-form" [ngClass]="{ 'error' : errorForm }" *ngIf="index < 1">Terminal línea móvil principal</h6>
<h6 class="subtitulo-pack-form" [ngClass]="{ 'error' : errorForm }" *ngIf="index >= 1">Terminal línea móvil</h6>

<div class="jumbotron-form2" [ngClass]="{ 'error' : errorForm }">
    <div class="d-flex justify-content-between align-items-center">
        <div *ngIf="isKratos">
            <span class="label-ad-text2">Modelo</span>
            <br>
            <!-- Modelo -->
            <span class="label-ad-text">
                <span *ngIf="terminal == null || paymentType == null">-</span>
                <span *ngIf="terminal && paymentType">{{ terminal?.name }} </span>
                <span *ngIf="terminal && paymentType && paymentType === 'unico'" class="price">
                    {{ terminal?.price }}€
                </span>
                <span *ngIf="terminal && paymentType && paymentType === 'VAP'" class="price"> 
                    {{ +terminal?.initial_payment === 0 ? terminal?.payment_quota + ' € x ' + terminal?.payment_months + 'meses' : terminal?.initial_payment + ' € + (' + terminal?.payment_quota + ' € x ' + terminal?.payment_months + 'meses)' }}
                </span>
            </span>
        </div>
        <div *ngIf="!isKratos">
            <span class="label-ad-text2">Modelo</span>
            <br>
            <!-- Modelo -->
            <span class="label-ad-text">
                    <span *ngIf="terminal == null || paymentType == null">-</span>
                    <span *ngIf="terminal && paymentType">{{ terminal?.brand }} {{ terminal?.name }} </span>
                    <span *ngIf="terminal && paymentType && paymentType === 'unico'" class="price">{{ terminal?.price }}€</span>
                    <span *ngIf="terminal && paymentType && paymentType === 'VAP'" class="price"> {{ terminal?.initial_payment-0 === 0 ? terminal?.payment_quota + ' € x ' + terminal?.payment_months + 'meses' : terminal?.initial_payment + ' € + (' + terminal?.payment_quota + ' € x ' + terminal?.payment_months + 'meses)' }}</span>
                </span>
        </div>
        <small class="text-muted btn-muted">
            <a href="javascript:void(0)" (click)="removeSelectedTerminal()" *ngIf="terminal != null && paymentType != null">
                <img src="./assets/img/trash.svg" class="img-fluid ico-title-trash" width="17">
            </a>
            <button class="btn btn-green btn-sm" role="button" (click)="open(content)">Añadir</button>
        </small>
    </div>
</div>
<mat-error *ngIf="changeTerminal">
    Hemos eliminado el terminal seleccionado al ser incompatible con el tipo de operación
</mat-error>
